import { Route } from '@angular/router';
import { LayoutBlankView, LayoutChatView } from './shared/layout';
import { ChatProvider } from './observatory-single/providers/chat-provider';
import { SharedChatProvider } from './observatory-single/providers/chat-shared-provider';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutBlankView,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./observatory-single/views/executive-view/executive-view').then((m) => m.ExecutiveView),
      },
    ],
  },
  {
    path: 'observatorio-ejecutivo',
    component: LayoutBlankView,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./observatory-single/views/executive-view/executive-view').then((m) => m.ExecutiveView),
      },
    ],
  },
  {
    path: 'share/:id',
    component: LayoutChatView,
    providers: [{ provide: ChatProvider, useClass: SharedChatProvider }],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./observatory-single/components/chat-panel/chat-panel-component').then((m) => m.ChatPanelComponent),
      },
    ],
  },
  {
    path: 'chat/new',
    component: LayoutChatView,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./observatory-single/components/chat-panel/chat-panel-component').then((m) => m.ChatPanelComponent),
      },
    ],
  },
];
